import * as React from 'react';
import { ComponentProps } from '../common/types';
import styles from './hidden.scss';

export const Hidden = (props: ComponentProps) => ( //eslint:disable-line
  <div id={props.componentId} className={styles.hidden}/>
);
